/*=================================================
    summary: 老師 看 學生考卷 語音辨識題 Fluency 單元
             語音辨識題
             練習 口語練習            LUSeqNo: 28
             Practice Fluency

    remarks: 000 Tim 2021/12/16 Create
             001 Tim 2021/12/23 加入 PaintedMe流程
=================================================*/
import React, { useState, useEffect, useRef } from 'react'
import cssAssignmentFluency from './AssignmentFluency.module.scss'
import '../../../../Utils/OldContentInlinClass.css'
import {GlobalLibs} from 'bc-react-package'

// #region Member Variables
let mblnInitialized = false

let marrDisplayQuestion = []
let mintMainCharacterID = -1
// #endregion Member Variables


const COMP_NAME = "AssignmentFluency"

function AssignmentFluency(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init State
    const [updateDataTime, setUpdateDataTime] = useState(0)
    const [questionPlayAudioIndex, setQuestionPlayAudioIndex] = useState(-1)
    const [answerPlayAudioIndex, setAnswerPlayAudioIndex] = useState(-1)
    // #endregion Init State

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    
    mrefPaintedMe.current = PaintedMe
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true

        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)    
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")

            window.AudioLibs.RemoveEventHandlerRef(window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
            window.AudioLibs.RemoveEventHandlerRef(window.AudioLibs.RegisterEventTypeEnum.AudioCanPlay)

            window.AudioLibs.StopAudio()
            mblnInitialized = false

            setUpdateDataTime(0)
        }
    }, [])


    // #region OnTapHandler
    /*===========================================
    summary: 點選 題目 聲音播放
    remarks: 000 Tim 2021/12/17 Create
    ===========================================*/
    function QuestionAudioPlayOnTapHandler(AudioUrl, QuestionIndex)
    {
        console.log(COMP_NAME + ".QuestionAudioPlayOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        OpenLoadingMask(window.gAppUI.MSG_LoadMask_LoadAudioData)

        window.AudioLibs.PlayAudio(AudioUrl)

        setQuestionPlayAudioIndex(QuestionIndex)
        setAnswerPlayAudioIndex(-1)
    } // end of QuestionAudioPlayOnTapHandler

    /*===========================================
    summary: 點選 學生作答 聲音播放
    remarks: 000 Tim 2021/12/17 Create
    ===========================================*/
    function AnswerAudioPlayOnTapHandler(AudioUrl, QuestionIndex)
    {
        console.log(COMP_NAME + ".AnswerAudioPlayOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        OpenLoadingMask(window.gAppUI.MSG_LoadMask_LoadAudioData)

        window.AudioLibs.PlayAudio(AudioUrl)

        setQuestionPlayAudioIndex(-1)
        setAnswerPlayAudioIndex(QuestionIndex)
    } // end of QuestionAudioPlayOnTapHandler
    // #endregion OnTapHandler

    // #region Other EventHandler
    /*===========================================
    summary: 播放聲音 結束事件
    remarks: 000 Tim 2021/12/17 Create
    ===========================================*/
    function PlayAudioEndHandler()
    {
        console.log(COMP_NAME + ".PlayAudioEndHandler")

        setQuestionPlayAudioIndex(-1)
        setAnswerPlayAudioIndex(-1)
    } // end of PlayAudioEndHandler

    /*===========================================
    summary: 音檔 讀取完畢 可以播放 
    remarks: 000 Tim 2021/12/17 Create
    ===========================================*/
    function AudioCanplayHandler()
    {
        console.log(COMP_NAME + ".AudioCanplayHandler")

        CloseLoadingMask()
    } // end of AudioCanplayHandler
    // #endregion Other EventHandler

    // #region LoadingMask Functions
    /*===========================================
    summary: 開啟 讀取中 效果
    remarks: 000 Tim 2021/12/17 Create
    ===========================================*/
    function OpenLoadingMask(LoadingMsg)
    {
        console.log(COMP_NAME + ".OpenLoadingMask")

        let objCallbackData = {
            "Action": "OpenLoadingMask",
            "Message": LoadingMsg
        }
        props.CallbackRef(objCallbackData)
    } // end of OpenLoadingMask

    /*===========================================
    summary: 關閉 讀取中 效果
    remarks: 000 Tim 2021/12/17 Create
    ===========================================*/
    function CloseLoadingMask()
    {
        console.log(COMP_NAME + ".CloseLoadingMask")
        let objCallbackData = {
            "Action": "CloseLoadingMask"
        }
        props.CallbackRef(objCallbackData)
    } // end of CloseLoadingMask
    // #endregion LoadingMask Functions

    // #region Other Functions
    /*===========================================
    summary: componentDidMount 程式進入 處理Props資料
    remarks: 000 Tim 2021/12/23 Create
    ===========================================*/
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe")

        window.AudioLibs.RegisterEventHandlerRef(PlayAudioEndHandler, window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
        window.AudioLibs.RegisterEventHandlerRef(AudioCanplayHandler, window.AudioLibs.RegisterEventTypeEnum.AudioCanPlay)

        marrDisplayQuestion = FormatFluencyQuestionData(props.LearningUnitData, props.TeacherAssignmentData)

        setUpdateDataTime(new Date().getTime())
    } // end of PaintedMe

    /*===========================================
    summary: 初始化 語音辨識題 答案資料
    remarks: 000 Tim 2021/12/16 Create
    ===========================================*/
    function FormatFluencyQuestionData(LearningUnit, TeacherAssignment)
    {
        console.log(COMP_NAME + ".FormatFluencyQuestionData: ", LearningUnit, TeacherAssignment)

        let arrSentence = LearningUnit.Sentence
        let arrSentence4ReadAloud = LearningUnit.Sentence4ReadAloud
        let arrDisplayQuestion = []
        let objDisplayQuestion = null

        let intSQIndex = 0
        let intSQCount = arrSentence.length
        let arrAnswer = []
        let objAnswer = null
        let intNAIndex = 0

        let objTRAnswer = null

        if (
            (typeof(TeacherAssignment) !== 'undefined') &&
            (TeacherAssignment !== null) &&
            (typeof(TeacherAssignment.NewAssignList) !== 'undefined') &&
            (TeacherAssignment.NewAssignList !== null) &&
            (TeacherAssignment.NewAssignList.length > 0) &&
            (typeof(TeacherAssignment.NewAssignList[intNAIndex]) !== 'undefined') &&
            (TeacherAssignment.NewAssignList[intNAIndex] !== null) &&
            (typeof(TeacherAssignment.NewAssignList[intNAIndex].AnswerList) !== 'undefined') &&
            (TeacherAssignment.NewAssignList[intNAIndex].AnswerList !== null) &&
            (TeacherAssignment.NewAssignList[intNAIndex].AnswerList.length > 0)
            )
        {
            arrAnswer = TeacherAssignment.NewAssignList[intNAIndex].AnswerList
        }

        for (intSQIndex = 0; intSQIndex < intSQCount; intSQIndex++)
        {
            objDisplayQuestion = {
                "AssignID": TeacherAssignment.NewAssignList[intNAIndex].AssignID,
                "TRSeqNo": arrSentence4ReadAloud[intSQIndex].SeqNo,
                "TRPIndex": arrSentence4ReadAloud[intSQIndex].ParagraphIdx,
                "QuestionText": "",
                "TextWithoutSymbol": arrSentence4ReadAloud[intSQIndex].TextWithoutSymbol,
                "QuestionAudioUrl": "",
                "Character": {
                    "ID": parseInt(arrSentence[intSQIndex].Character.ID),
                    "Name": ""
                },
                "AnswerAudioUrl": "",
                "Score": -1,
                "CharScore": [],
                "IsPassed": false
            }

            if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
            {
                objDisplayQuestion.QuestionText = arrSentence4ReadAloud[intSQIndex].Major
                objDisplayQuestion.Character.Name = arrSentence[intSQIndex].Character.MajorName
            }
            else
            {
                objDisplayQuestion.QuestionText = arrSentence4ReadAloud[intSQIndex].Minor
                objDisplayQuestion.Character.Name = arrSentence[intSQIndex].Character.MinorName
            }

            objDisplayQuestion.QuestionAudioUrl = window.Globals.GetResourceUrl(props.BookCatID, props.LessonID, window.gResourceTypeEnum.Audio, arrSentence[intSQIndex].AudioFN)

            let intTRSeqNo = parseInt(objDisplayQuestion.TRSeqNo)
            let intTRPIndex = parseInt(objDisplayQuestion.TRPIndex)

            // 找出 使用者 選擇的答案
            objAnswer = arrAnswer.find(AnswerData => 
                (
                    (parseInt(AnswerData.TRSeqNo) === parseInt(intTRSeqNo)) && 
                    (parseInt(AnswerData.TRPIndex) === parseInt(intTRPIndex))
                )
            )

            console.log(COMP_NAME + ".FormatFluencyQuestionData: objAnswer: ", objAnswer)

            if (
                (typeof(objAnswer) !== 'undefined') &&
                (objAnswer !== null)
                )
            {
                if (
                    (typeof(objAnswer.TRScore) !== 'undefined') &&
                    (objAnswer.TRScore !== null) &&
                    (objAnswer.TRScore !== "") &&
                    (parseFloat(objAnswer.TRScore) >= 0)
                    )
                {
                    objDisplayQuestion.Score = parseInt(parseFloat(objAnswer.TRScore) * 100)
                } // end of if (parseFloat(objAnswer.TRScore) >= 0)

                if (
                    (typeof(objAnswer.TRAudioFN) !== 'undefined') &&
                    (objAnswer.TRAudioFN !== null) &&
                    (objAnswer.TRAudioFN !== "")
                    )
                {
                    objDisplayQuestion.AnswerAudioUrl = window.Globals.GetUserNewAssignmentUrl(objDisplayQuestion.AssignID, objAnswer.TRAudioFN)
                } // end of if (objAnswer.TRAudioFN !== "")

                if (
                    (typeof(objAnswer.TRAnswer) !== 'undefined') &&
                    (objAnswer.TRAnswer !== null) &&
                    (objAnswer.TRAnswer !== "")
                    )
                {
                    objTRAnswer = JSON.parse(objAnswer.TRAnswer)

                    if (
                        (typeof(objTRAnswer.CharScore) !== 'undefined') &&
                        (objTRAnswer.CharScore !== null) &&
                        (objTRAnswer.CharScore.length >= 0)
                        )
                    {
                        objDisplayQuestion.CharScore = objTRAnswer.CharScore
                    }

                    if (
                        (typeof(objTRAnswer.IsPassed) !== 'undefined') &&
                        (objTRAnswer.IsPassed !== null)
                        )
                    {
                        objDisplayQuestion.IsPassed = objTRAnswer.IsPassed
                    } 
                } // end of if (objAnswer.TRAnswer !== "")
            } // end of if (objAnswer !== null)
                
            arrDisplayQuestion.push(objDisplayQuestion)
        } // end of for (intSQIndex = 0;

        console.log(COMP_NAME + ".FormatFluencyQuestionData arrDisplayQuestion: ", arrDisplayQuestion)


        mintMainCharacterID = parseInt(arrDisplayQuestion[0].Character.ID)

        return arrDisplayQuestion
    } // end of FormatFluencyQuestionData
    // #endregion Other Functions

    // #region Get ClassName
    /*===========================================
    summary: 取得 題目 聲音播放按鈕 Cls
    remarks: 000 Tim 2021/12/17 Create
    ===========================================*/
    function GetQuestionAudioPlayCls(QuestionIndex, StateQuestionPlayAudioIndex, StateAnswerPlayAudioIndex)
    {
        let objCls = cssAssignmentFluency.btnQuestionAudioPlay

        if (
            (StateAnswerPlayAudioIndex === -1) &&
            (StateQuestionPlayAudioIndex === QuestionIndex)
            )
        {
            objCls = cssAssignmentFluency.btnQuestionAudioPlayDisabled
        }

        return objCls
    } // end of GetQuestionAudioPlayCls

    /*===========================================
    summary: 取得 學生作答 聲音播放按鈕 Cls
    remarks: 000 Tim 2021/12/17 Create
    ===========================================*/
    function GetAnswerAudioPlayCls(QuestionIndex, StateQuestionPlayAudioIndex, StateAnswerPlayAudioIndex)
    {
        let objCls = cssAssignmentFluency.btnAnswerAudioPlay

        if (
            (StateQuestionPlayAudioIndex === -1) &&
            (StateAnswerPlayAudioIndex === QuestionIndex)
            )
        {
            objCls = cssAssignmentFluency.btnAnswerAudioPlayDisabled
        }

        return objCls
    } // end of GetAnswerAudioPlayCls

    /*===========================================
    summary: 取得 分數顯示 Cls
    remarks: 000 Tim 2021/12/17 Create
    ===========================================*/
    function GetScoreCls(IsPassed)
    {
        let objCls = cssAssignmentFluency.divScoreScoreFail

        if (IsPassed)
        {
            objCls = cssAssignmentFluency.divScoreSuccess
        }

        return objCls
    } // end of GetScoreCls

    /*===========================================
    summary: 取得 作答文字顯示 Cls
    remarks: 000 Tim 2021/12/17 Create
    ===========================================*/
    function GetAnswerCharCls(CharScore)
    {
        let objCls = cssAssignmentFluency.divAnswerCharSuccess

        if (CharScore === -1)
        {
            objCls = cssAssignmentFluency.divAnswerCharSuccess
        }
        else if (CharScore < 0.6)
        {
            objCls = cssAssignmentFluency.divAnswerCharFail
        }
        else
        {
            objCls = cssAssignmentFluency.divAnswerCharSuccess
        }

        return objCls
    } // end of GetAnswerCharCls
    // #endregion Get ClassName

    // #region Render元件
    /*===========================================
    summary: Right Name Cell 顯示Component  
    remarks: 000 Tim 2021/12/16 Create
    ===========================================*/
    function ComponentRightNameCell( {MainCharacterID, Character} )
    {   
        let objBlock = ""
        if (MainCharacterID !== Character.ID)
        {
            objBlock =  <>
                            <div className={cssAssignmentFluency.divRightNameText}>
                                {Character.Name}
                            </div>
                            <div className={cssAssignmentFluency.divRightCover}/>
                        </>
        }

        return(
            <div className={cssAssignmentFluency.divRightNameCell}>
                {objBlock}
            </div>
        )
    } // end of ComponentRightNameCell

    /*===========================================
    summary: Left Name Cell 顯示Component  
    remarks: 000 Tim 2021/12/16 Create
    ===========================================*/
    function ComponentLeftNameCell( {MainCharacterID, Character} )
    {   
        let objBlock = ""
        if (MainCharacterID === Character.ID)
        {
            objBlock =  <>
                            <div className={cssAssignmentFluency.divLeftNameText}>
                                {Character.Name}
                            </div>
                            <div className={cssAssignmentFluency.divLeftCover}/>
                        </>
        }

        return(
            <div className={cssAssignmentFluency.divLeftNameCell}>
                {objBlock}
            </div>
        )
    } // end of ComponentLeftNameCell
    // #endregion Render元件

    // #region Render
    /*===========================================
    summary: Render Answer Text Cell 的顯示
    remarks: 000 Tim 2021/12/17 Create
    ===========================================*/
    function RenderAnswerTextCellWrapper(Score, CharScore, QuestionText)
    {
        if (Score === 100)
        {
            return (                
                <div className={cssAssignmentFluency.divAnswerTextCell}>
                    {QuestionText}
                </div>
            )
        }
        else
        {
            let arrQuestionChar = QuestionText.split("")

            return (                
                <div className={cssAssignmentFluency.divAnswerTextCell}>
                    {arrQuestionChar.map((CharData, CharIndex) =>
                        <div key={CharIndex} className={GetAnswerCharCls(CharScore[CharIndex])}>
                            {CharData}
                        </div>
                    )}
                </div>
            )
        }
    } // end of RenderAnswerTextCellWrapper

    /*===========================================
    summary: Render Question Bottom Row 的顯示
    remarks: 000 Tim 2021/12/17 Create
    ===========================================*/
    function RenderQuestionBottomRowWrapper(QuestionData, QuestionIndex)
    {
        return (
            <div className={cssAssignmentFluency.divQuestionBottomRow}>
                <div className={GetAnswerAudioPlayCls(QuestionIndex, questionPlayAudioIndex, answerPlayAudioIndex)} onClick={() => AnswerAudioPlayOnTapHandler(QuestionData.AnswerAudioUrl, QuestionIndex)}/>
                <div className={GetScoreCls(QuestionData.IsPassed)}>
                    {QuestionData.Score}
                </div>
                
                {RenderAnswerTextCellWrapper(QuestionData.Score, QuestionData.CharScore, QuestionData.QuestionText)}
            </div>
        )
    } // end of RenderQuestionBottomRowWrapper

    /*===========================================
    summary: Render Question Top Row 的顯示
    remarks: 000 Tim 2021/12/17 Create
    ===========================================*/
    function RenderQuestionTopRowWrapper(QuestionData, QuestionIndex)
    {
        return (
            <div className={cssAssignmentFluency.divQuestionTopRow}>
                <div className={GetQuestionAudioPlayCls(QuestionIndex, questionPlayAudioIndex, answerPlayAudioIndex)} onClick={() => QuestionAudioPlayOnTapHandler(QuestionData.QuestionAudioUrl, QuestionIndex)}/>
                <div className={cssAssignmentFluency.divQuestionTextCell}>
                    {QuestionData.QuestionText}
                </div>
            </div>
        )
    } // end of RenderQuestionTopRowWrapper

    /*===========================================
    summary: Render Question Cell 的顯示
    remarks: 000 Tim 2021/12/17 Create
    ===========================================*/
    function RenderQuestionCellWrapper(QuestionData, QuestionIndex)
    {
        return (
            <div className={cssAssignmentFluency.divQuestionCell}>
                {RenderQuestionTopRowWrapper(QuestionData, QuestionIndex)}
                {RenderQuestionBottomRowWrapper(QuestionData, QuestionIndex)}
            </div>
        )
    } // end of RenderQuestionCellWrapper

    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/12/16 Create
    ===========================================*/
    function RenderContentWrapper(StateUpdateDataTime)
    {
        if (StateUpdateDataTime > 0)
        {
            return (
                <div className={cssAssignmentFluency.divContent}>
                    {marrDisplayQuestion.map((QuestionData, QuestionIndex) =>
                        <div key={QuestionIndex} className={cssAssignmentFluency.divQuestionMain}>
                            <ComponentLeftNameCell MainCharacterID={mintMainCharacterID} Character={QuestionData.Character}/>

                            {RenderQuestionCellWrapper(QuestionData, QuestionIndex)}

                            <ComponentRightNameCell MainCharacterID={mintMainCharacterID} Character={QuestionData.Character}/>
                        </div>
                    )}
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/12/16 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        return (
            <div className={cssAssignmentFluency.divMain}>
                {RenderContentWrapper(updateDataTime)}
            </div>
        )
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper()}
        </>
    )
    // #endregion Render
}
export default AssignmentFluency